<template>
    <account-picker
        v-model:account-no="expenseAccount"
        class="w-full min-w-[200px] ag-custom-component-popup"
        :accounts="bookkeepingAccounts"
        start-open
        @on-account-picker-closed="stopEditing"
    />
</template>

<script setup lang="ts">
import {SubAccount} from '@/subaccount/types/SubAccount'
import {computed} from 'vue'
import AccountPicker from '@/account-picker/AccountPicker.vue'
import {bookkeepingAccounts} from '@/bookkeeping-account/bookkeepingAccount.service'
import {fetchSuppliers, updateSubAccount} from '@/subaccount/subAccount.service'

const props = defineProps({
    params: {
        type: Object as () => {
            value: string,
            node: {
                data: SubAccount
            },
            stopEditing: () => void
        },
        required: true
    }
})

const subAccount = computed(() => {
    return props.params.node.data
})

const expenseAccount = computed({
    get: () => props.params.value,
    set: async (value) => {
        const updatedSubAcc = {
            ...subAccount.value,
            metadata: {
                ...subAccount.value.metadata,
                suggestions: {
                    ...subAccount.value.metadata.suggestions,
                    expenseAccount: value
                }
            }
        }
        await updateSubAccount(updatedSubAcc)
        await fetchSuppliers()
    }
})

const stopEditing = () => {
    props.params.stopEditing()
}

</script>

<style scoped>

</style>